import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgIconArrowLeft = (props, ref) => _jsx("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "currentColor", ref: ref, ...props, children: _jsx("path", { d: "M11.057 5.053a1 1 0 1 1 1.414 1.414L7.94 11h10.064a1 1 0 0 1 0 2H7.939l4.532 4.532a1 1 0 0 1-1.414 1.414l-5.532-5.532a2 2 0 0 1 0-2.828z" }) });
const ForwardRef = forwardRef(SvgIconArrowLeft);
export default ForwardRef;
